import { render } from "./SourceUrl.vue?vue&type=template&id=d3f34924"
import script from "./SourceUrl.vue?vue&type=script&lang=ts"
export * from "./SourceUrl.vue?vue&type=script&lang=ts"
script.render = render

export default script